<template>
  <div class="index">
    <my-header></my-header>
    <div class="main">
      <!-- 金额 -->
      <div class="money">Tzs {{ parseInt(amount || '0').toLocaleString() }}</div>
      <div class="line"></div>
      <div class="info">
        Payer Account Details
      </div>
      <div class="tip">Choose how you would like to pay</div>
      <div class="item">
        <div class="label"> Mobile Network</div>
        <div class="network">
          <select v-model="server">
            <option v-for="item in serverList" :value="item.storeServiceId">{{ item.serviceDisplayName }}</option>
          </select>
        </div>
      </div>
      <div class="item">
        <div class="label">Payer Phone Number</div>
        <div class="mobile">
          <input type="number" v-model="mobile" @input="limitLength"/>
        </div>
      </div>

      <div class="btn">
        <button class="btn-click" @click="submit">Make Payment</button>
      </div>
    </div>

    <van-overlay :show="overlayStatus" style="display: flex; justify-content: center; align-items: center;">
      <van-loading color="#1989fa" size="60px"/>
    </van-overlay>


    <div class="email-info">
      <p class="email-1">If you have any question，connect us by email</p>
      <p class="email-2">{{ email }}</p>
    </div>
  </div>
</template>

<script>
import MyHeader from "../ngn/components/header.vue";

export default {
  components: {MyHeader},
  data() {
    return {
      no: null,
      amount: 0,
      email: null,
      mobile: null,
      server: null,
      overlayStatus: false,
      serverList: [],
      ConfirmLoading: false
    }
  },
  mounted() {
    this.overlayStatus = true
    this.Params = this.$route.query
    // 检查no参数是否为空
    this.no = this.Params.no
    this.payment()
  },
  beforeDestroy() {
    this.no = null
  },
  methods: {
    payment() {
      this.axios.get(`/api/order/orderStatus/${this.no}`).then(res => {
          this.overlayStatus = false
          if (res.data.code == 0) {
            console.log('order', res.data.data)
            if (res.data.data.status == 1) {
              this.$router.push({path: '/tzs/success', query: {no: res.data.data.orderId}})
            } else if (res.data.data.status == 2) {
              this.$router.push({path: '/tzs/fail', query: {no: res.data.data.orderId}})
            } else {
              if (res.data.data.sourceAccountNumber) {
                this.$router.push({path: '/tzs/processing', query: {no: res.data.data.orderId}})
              } else {
                this.amount = res.data.data.amount
                this.serverList = JSON.parse(res.data.data.extra);
                this.server = this.serverList[0].storeServiceId; // 获取第一个元素
                this.email = res.data.data.logoEmail
              }
            }
          } else {
            this.$toast(res.data.error)
          }
        }
      )
    },
    submit() {
      console.log('提交')
      if (this.mobile == null || this.mobile == '') {
        this.$toast('Please enter your mobile number')
        return;
      } else if (this.mobile.length < 9) {
        this.$toast("Please enter a valid phone number")
        return;
      }
      this.overlayStatus = true
      this.axios.post('/api/order/submitUssd',
        {
          orderId: this.no,
          mobile: this.mobile,
          server: this.server
        }).then(res => {
        this.overlayStatus = false
        console.log(res.data)
        if (res.data.code == 0) {
          this.$router.push({path: '/tzs/processing', query: {no: res.data.data.orderId}})
        } else {
          this.$toast(res.data.error)
        }
      })

    },
    limitLength() {
      if (this.mobile > 9) {
        this.mobile = this.mobile.slice(0, 9);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  padding: 20px;
}


.tip {
  font-size: .23rem;
  margin-top: 10px;
}

.main {
  background-color: #ffffff;
  border-radius: 0.4rem;
  margin: 0.4rem 0;
  padding: 0.48rem 0;
}


.info {
  margin-top: 20px;
  margin-bottom: 5px;
  color: #151515;
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
}

.item {
  padding: 0 20px;
  margin: 20px 0;

  .label {
    margin: 0.15rem 0;
    font-size: 0.25rem;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #151515;
    text-align: left;
  }


  .network {
    height: 0.8rem;
    background: #FFFFFF;
    border-radius: 0.16rem;
    border: 0.02rem solid #C6C6D3;

    select {
      padding: 0 .24rem;
      height: 0.8rem;
      width: 100%;
      font-size: 0.32rem;
      font-family: PingFang-SC-Medium, PingFang-SC;
      border: none;
      background: url('../../assets/images/tzs/arrow-icon.png') no-repeat right center; /* 使用自定义箭头图标 */
      background-position: calc(100% - 12px) center; /* 设置箭头图标位置，距离右边 10px */


      -webkit-appearance: none; /* Webkit 内核浏览器 */
      -moz-appearance: none; /* Firefox 浏览器 */
      appearance: none; /* 其他浏览器 */
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
      -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
      -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
      transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    }


    select:focus {
      outline: none;
    }

    option {
      font-size: 0.25rem;
    }

  }

  .mobile {
    height: 0.8rem;
    background: #FFFFFF;
    border-radius: 0.16rem;
    border: 0.02rem solid #C6C6D3;
    display: flex;


    input {
      width: 100%;
      font-size: 0.32rem;
      font-family: PingFang-SC-Medium, PingFang-SC;
      color: #151515;
      line-height: 0.8rem;
      margin-left: 0.24rem;
      background: none;
      border: none;
    }
  }
}

.btn {
  height: 1rem;
  padding: 0 20px;
  margin-top: 50px;
  margin-bottom: 20px;

  .btn-click {
    width: 100%;
    height: 1rem;
    border: none;
    background-color: rgb(12, 31, 102);
    border-radius: 0.16rem;
    font-size: 0.3rem;
    font-family: PingFang-SC-Heavy, PingFang-SC;
    font-weight: bold;
    color: #ffffff;
  }
}

.money {
  font-size: 0.45rem;
  font-weight: bold;
  text-align: center;
  color: rgb(12, 31, 102);
  margin-bottom: 20px;
}

.line {
  height: 1px;
  border-bottom: 1px dashed #d5d4d4;
}

.email-info {
  margin-top: 0.32rem;
  font-size: 0.26rem;
  font-family: PingFang-SC-Medium, PingFang-SC;


  .email-1 {
    font-weight: 500;
    color: #282E34;
  }

  .email-2 {
    font-weight: bold;
    color: #39B549;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/tzs/index.vue